import * as React from "react";
import { Input, Table } from "reactstrap";
import { settings } from "../../constants";
import IPredicate from "../../models/IPredicate";

export interface IPredicateDetailsTableProps {
  predicate: IPredicate;
}

const PredicateDetailsTable: React.SFC<IPredicateDetailsTableProps> = (
  props: IPredicateDetailsTableProps
) => {
  const { predicate } = props;
  const { displayName, name, isKpiGrouping, isEnabled } = predicate;
  const { allowDisableGroups } = settings;
  return (
    <Table striped={true}>
      <tbody>
        <tr>
          <th scope="row">Name</th>
          <td> {name}</td>
        </tr>
        <tr>
          <th scope="row">Display Name</th>
          <td> {displayName}</td>
        </tr>
        <tr>
          <th scope="row">Is KPI Grouping</th>
          <td>
            <Input type="checkbox" checked={isKpiGrouping} readOnly={true} />
            {isKpiGrouping}
          </td>
        </tr>
        {allowDisableGroups && (
          <tr>
            <th scope="row">Enabled</th>
            <td>
              <Input type="checkbox" checked={isEnabled} readOnly={true} />
              {isEnabled}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default PredicateDetailsTable;
